
import { defineComponent, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useReflectiveInjector } from '@tanbo/vue-di-plugin'
import ContentAdaptLayout from '@/views/dashboard/_components/content-adapt-layout/content-adapt-layout.vue'
import GroupPolicyDrawer from '@/views/dashboard/_components/group-policy-settings/group-policy-drawer.vue'
import { PolicyCommonService, StrategyListDataCommon } from '@/views/dashboard/policy/policy-common.service'
import { PolicyDeployService } from '@/views/dashboard/policy/policy-deploy/policy-deploy.service'
import { Group } from '@/views/dashboard/_type/group'

export default defineComponent({
  components: {
    GroupPolicyDrawer,
    ContentAdaptLayout
  },

  setup (props) {
    const { t } = useI18n()
    const injector = useReflectiveInjector([PolicyDeployService, PolicyCommonService])
    const service = injector.get(PolicyDeployService)
    const policyCommonService = injector.get(PolicyCommonService)

    const tableData = ref<Group[]>([])
    const strategyList = ref<StrategyListDataCommon[]>([])
    const activeRow = ref({} as StrategyListDataCommon)
    const isLoading = ref(false)
    const groupPolicyDrawerVisible = ref(false)
    const usedGroupVisible = ref(false)
    const groupPolicyDrawerOperateType = ref('edit')

    function updateData () {
      isLoading.value = true
      service.getGroupStrategy().then(response => {
        tableData.value = [response.group] || [{} as any]
      }).finally(() => {
        isLoading.value = false
      })
    }

    function updateStrategyList () {
      isLoading.value = true
      policyCommonService.getStrategyList({
        page: 1,
        limit: 9999
      }).then(response => {
        strategyList.value = response.data || []
        strategyList.value.splice(0, 0, { name: t('safeProtectionModule.followParentPolicy'), id: '-1' } as any)
      }).finally(() => {
        isLoading.value = false
      })
    }

    function addPolicy () {
      activeRow.value = {} as StrategyListDataCommon
      groupPolicyDrawerVisible.value = true
    }

    function changePolicy (strategyId: string, group: Group) {
      service.deployStrategy({ group_id: group.group_id, strategy_id: strategyId }).then(() => {
        group.strategy_id = strategyId
      })
    }

    updateData()
    updateStrategyList()

    return {
      tableData,t,
      strategyList,
      activeRow,
      isLoading,
      groupPolicyDrawerVisible,
      usedGroupVisible,
      groupPolicyDrawerOperateType,
      updateData,
      addPolicy,
      changePolicy,
      updateStrategyList,
    }
  }
})
